import React from 'react';
import { Box, Text } from '@wix/design-system';
import { TimerSmall } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { COLORS } from '../../../../utils/theme';
import { DATA_HOOKS } from '../../../../dataHooks';
var convertMinutesToHalfHours = function (minutes) {
    var hours = minutes / 60;
    var roundedHours = Math.round(hours * 2) / 2; // Round to the nearest 0.5
    return roundedHours;
};
export var ReadingTime = function (_a) {
    var readingTimeInMinutes = _a.readingTimeInMinutes;
    var t = useTranslation().t;
    var hours = convertMinutesToHalfHours(readingTimeInMinutes);
    return (React.createElement(Box, { className: 'readingTimeInMinutes', verticalAlign: "middle" },
        React.createElement(TimerSmall, { color: COLORS.D40, className: 'timerIcon' }),
        React.createElement(Text, { size: "tiny", color: COLORS.D40, className: 'timeToRead', dataHook: DATA_HOOKS.SEARCH_RESULT_ITEM_TIME_TO_READ }, hours >= 1 ?
            t('shared.informative-article-time-to-read-hours', { hours: hours }) :
            t('shared.informative-article-time-to-read', { time: readingTimeInMinutes }))));
};
//# sourceMappingURL=index.js.map